export default __webpack_public_path__ + "static/media/check-booking-ok.4b27e1c5.gif";